import { Component, HostListener, Inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { log } from 'node:console';
import { AppConfigService } from '../../../services/config/app-config.service';
import { SatesListService } from '../../../services/raintree/Transmission/sates-list.service';
import { DistrictListService } from '../../../services/raintree/Transmission/district-list.service';

@Component({
  selector: 'app-mandir-bill-filter',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, MatSelectModule, FormsModule],
  templateUrl: './mandir-bill-filter.component.html',
  styleUrls: [
    './mandir-bill-filter.component.scss',
    '../../../../styles/_dropdown.scss',
  ],
})
export class MandirBillFilterComponent {
  FILTERS: any = {
    fy: 0,
    addr: 1,
  };

  filterOptions: any[] = [
    {
      title: 'Financial Year',
      id: 'fy',
    },
    {
      title: 'Address',
      id: 'addr',
    },
  ];

  FY = [
    { key: '2026', value: '2026-2025' },
    { key: '2025', value: '2025-2024' },
    { key: '2024', value: '2024-2023' },
    { key: '2023', value: '2023-2022' },
    { key: '2022', value: '2022-2021' },
    { key: '2021', value: '2021-2020' },
  ];

  // FY: { key: string, value: string }[]=[];
  selectedFY = new FormControl('');
  States: any[] = [];
  seletedState = new FormControl('');
  // districts: any[] = [];
  isAllDistrict: boolean = false;
  dropDownDist:any[]=[]
  selectedDist = new FormControl('');
  allPerm: Record<string, any> = {};
  
  // filterForm!: FormGroup;

  selectedFilterIndex: number = 0;
  maxDate = new Date().toISOString().split('T')[0];
  centersList: any;
  bankList: any = [];
  selectedBank: any[] = [];
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MandirBillFilterComponent>,
    private _appConfig: AppConfigService,
    public stateTransmissionService: SatesListService,
    public districtTransmissionService: DistrictListService,
  ) {
    if (data) {
      this.selectedFY.setValue(data.fy);
    }
  }

  ngOnInit() {
    this.allPerm = this._appConfig.fetchPermissionv3ByViewName();

    this.getStateList();

    console.log(this.data, this.dropDownDist, 'filterData');
      if( this.data?.isAllDistrict){
      this.getDistrictList(this.data?.state)
    }
    else if(this.data?.district){
       this.seletedState.setValue(this.data?.state);
      this.selectedDist.setValue(this.data?.district);
    }
  }

  getStatesDistrictList() {
    this.isAllDistrict = true
    this.isLoading = true;
    this.stateTransmissionService.getStatesList().subscribe({
      next: (response: any) => {
        if (!response.error) {
          let resp = response.data;
          resp.forEach((elm: any) => {
            this.States.push(elm.stateName);
          });
        }
      },
      error: (error) => {},
    });
  }

  getDistrictList(event: any) {
    this.districtTransmissionService.getDistrictList(event).subscribe({
      next: (response: any) => {
        if (!response.error) {
          let resp = response.data;
          this.dropDownDist = [];
          resp.forEach((elm: any) => {
            this.dropDownDist.push(elm.district_name);
          });
        }
      },
      error: (error) => {},
    });
  }

  getStateList() {
    let secondStateDist: any;
    const countryPerm = this.allPerm['INDIA'];
    if (countryPerm.allStatesPerm.length > 0) {
      this.getStatesDistrictList();
    } else {
      const statePerm = Object.keys(countryPerm.statePerms);
      this.States = [...statePerm];  
      const firstStateDist = Object.keys(countryPerm.statePerms[this.States[0]].districtPerms);
      if(this.data?.state){
      secondStateDist = Object.keys(countryPerm.statePerms[this.data?.state]?.districtPerms);
      }

      this.dropDownDist = this.data?.district ? secondStateDist : firstStateDist
     
      if(this.States.length === 1){
         this.seletedState.setValue(this.States[0]);
         if (this.dropDownDist.length === 1) {
              this.selectedDist.setValue(this.dropDownDist[0]);
          }
         
      }
      else{
        this.seletedState.setValue(this.States[0]);
        if (this.dropDownDist.length === 1) {
              this.selectedDist.setValue(this.dropDownDist[0]);
          }
      }
      
    }
  }

  generateFYList(years: number = 6) {
    const currentYear = new Date().getFullYear();
    const fyList = [];

    for (let i = 0; i < years; i++) {
      const y1 = currentYear - i;
      const y2 = y1 - 1;

      fyList.push({
        key: y1.toString(),
        value: `${y1}-${y2}`,
      });
    }

    return fyList;
  }

  onFYChange() { }
  
  onStateChange(event: any) {
    const countryPerm = this.allPerm['INDIA']
    if(countryPerm.allStatesPerm.length === 0){
    const stateObj = countryPerm.statePerms
    console.log(stateObj);
    
    const districtObj = Object.keys(stateObj[event].districtPerms)
    console.log(districtObj, 'dis');

    this.dropDownDist = [...districtObj] 
    }else{
      this.getDistrictList(event)
    }      
  }

  onDistChange() {}

  closeDialog() {
    this.dialogRef.close(false);
  }

  applyFilter() {
    this.dialogRef.close({
      financeYear: this.selectedFY.value,
      state: this.seletedState.value,
      district: this.selectedDist.value,
      isAllDistrict: this.isAllDistrict
    });
  }

  resetFilter() {     
    if (this.States.length > 1 || this.dropDownDist.length > 1) {
      this.selectedDist.setValue('');
      this.seletedState.setValue('');
    }
    this.selectedFY.setValue('');
  }

  selectFilterItem(i: number) {
    this.selectedFilterIndex = i;
  }
}
